<template>
    <CardShell>
        <div class="w-70-l ph4">

            <ToolPreviewShell class="pt4" :tool="listing" :imageIndex="imageIndex">
                <ImageStrip :images="listing.images" @select="imageIndex = $event" />
            </ToolPreviewShell>

        </div>
    </CardShell>
</template>

<script>
import CardShell from '@/components/global/CardShell.vue';
import ToolPreviewShell from '@/components/global/ToolPreviewShell.vue';

const TOOL = {
    brand: 'Makita',
    description: 'This is a makita drill',
    images: [{ path: require('@/assets/img/tools/axe.jpg') }]
};

import ImageStrip from '@/components/global/displayToolCore/ImageStrip.vue';

export default {
    data() {
        return {
            tool: TOOL,
            imageIndex: 0
        };
    },
    components: {
        CardShell,
        ToolPreviewShell,
        ImageStrip
    },
    props: {
        listing: {
            type: Object
        }
    }
};
</script>
